import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import { Sparkles, ArrowUpRight } from "lucide-react";

export const FaccetteTeaser = () => (
  <section className="py-24 md:py-32 px-6 md:px-12" data-testid="faccette-teaser-section">
    <div className="max-w-7xl mx-auto">
      <Reveal>
        <div className="bg-white border border-border rounded-[32px] overflow-hidden grid md:grid-cols-2">
          <img
            src="/casi/faccette-dopo.jpg"
            alt="Sorriso con faccette estetiche in zirconia"
            className="w-full h-64 md:h-full object-cover"
            loading="lazy"
          />
          <div className="p-8 md:p-12 flex flex-col justify-center">
            <p className="flex items-center gap-2 text-sm uppercase tracking-[0.2em] font-bold text-[#7D9285]">
              <Sparkles size={16} className="text-[#C98E6E]" /> Novità
            </p>
            <h2 className="mt-4 font-serif-display font-light text-3xl md:text-4xl text-[#15201A]">
              Faccette estetiche in <em className="italic text-[#385244]">zirconia</em>
            </h2>
            <p className="mt-5 text-base md:text-lg leading-relaxed text-[#5C6B61]">
              Un sorriso più bianco e armonioso da <strong className="text-[#15201A]">€450 a faccetta</strong>,
              con prova estetica in PMMA compresa. Nel 90% dei casi non bisogna "toccare" i denti.
              Scopri anche la protesi fissa su denti naturali.
            </p>
            <Link
              to="/protesi-e-faccette"
              className="mt-8 inline-flex items-center gap-2 self-start rounded-full bg-[#385244] hover:bg-[#2B4035] text-white text-base font-bold px-7 py-3.5 transition-colors duration-300 active:scale-95"
              data-testid="faccette-teaser-btn"
            >
              Scopri protesi fissa e faccette <ArrowUpRight size={18} />
            </Link>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
